// src/api/ota-api.ts

import { otaUpdatesUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeadersForMultipart } from "../util/build-axios-authentication-headers";

export const postConfigurationUpload = async (
  namespace: string,
  formData: FormData,
) => {
  const url = otaUpdatesUrlEnvVar();

  const headers = {
    ...buildAxiosAuthenticationHeadersForMultipart(),
  };

  try {
    const response = await axios.post(
      `${url}/api/v1/ns/${namespace}/configuration`,
      formData,
      {
        headers: headers,
      },
    );

    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      const message =
        err.response?.data?.detail ||
        err.response?.data?.message ||
        "Failed to upload configuration. Please try again later.";

      throw new Error(message);
    } else {
      throw new Error(
        "An unexpected error occurred while uploading configuration.",
      );
    }
  }
};
